import React from 'react'

import Box from 'components_new/atoms/Box'
import Button from 'components_new/atoms/Button'

interface ActionsProps {
  activeStep: number
  creating: boolean
  nextDisabled: boolean
  onChangeStep: (step: number) => void
  onClose: () => void
  onCreate: () => void
  selected: boolean
  stepsCount: number
}

const Actions = (props: ActionsProps) => {
  const {
    activeStep,
    creating,
    nextDisabled,
    onChangeStep,
    onClose,
    onCreate,
    selected,
    stepsCount
  } = props

  if (!selected) {
    return (
      <Button onClick={onClose} variant="text">
        Avbryt
      </Button>
    )
  }

  const isLastStep = stepsCount > 0 && activeStep === stepsCount - 1

  return (
    <Box
      sx={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}
    >
      <Button disabled={creating} onClick={onClose} variant="text">
        Avbryt
      </Button>

      <Box sx={{ display: 'flex' }}>
        <Button
          disabled={creating}
          // Stepping back past the first step returns to the source picker.
          onClick={() => onChangeStep(activeStep - 1)}
          variant="text"
        >
          Föregående
        </Button>
        <Button
          disabled={nextDisabled}
          loading={creating}
          onClick={isLastStep ? onCreate : () => onChangeStep(activeStep + 1)}
        >
          {isLastStep ? 'Lägg till' : 'Nästa'}
        </Button>
      </Box>
    </Box>
  )
}

export default Actions
